import { Component, OnInit, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { AzureFunctionsService, Status, Subscription } from 'src/app/azurefunctions/azure-functions.service';
import { BaseAutorizeComponent } from '../shared/base-authorize.component';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { AzureadHelperService } from '../azuread/azuread-helper.service';
import { ConfigLoaderService } from '../shared/config-loader.service';


@Component({
  selector: 'app-reqeust-onboarding',
  templateUrl: './request-onboarding.component.html',
  styleUrls: ['./request-onboarding.component.css']
})
export class RequestOnboardingComponent extends BaseAutorizeComponent {
  
  email: string;
  errorMessage: string;
  submitted: boolean = false;
  working: boolean;
  wrongEmail: boolean ;
  emailToContact: string;
  

  constructor(broadcastService: BroadcastService, authService: MsalService, private functionsService: AzureFunctionsService, private adHelper: AzureadHelperService, private configService: ConfigLoaderService) { 
    super(broadcastService, authService)
  }

  onInitChild() {
     this.email = this.emailToContact = this.authService.getAccount().userName;
  }
  // => syntax to map "this" to current class
  onWrongEmailChanged = (value) => {
    this.wrongEmail = value;
  }

  // => syntax to map "this" to current class
  onEmailToContactChanged = (value) => {
    this.emailToContact = value;
  }

  submitRequest(){
    this.errorMessage = null;
    this.working = true;
    this.adHelper.loginAdminConsenstPopup(this.configService.Configuration.msal.clientId).then(() => {
      this.functionsService.submitOnboardingRequest(this.emailToContact).then(
        () => {
          this.submitted = true;
          this.working = false;
        },
        (e) => {
          this.errorMessage = e.error || e.message;
          this.working = false;
        });
    })
    
  }
}
